import "core-js/modules/es6.function.name.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.string.includes.js";
import LinksNewsletter from './LinksNewsletter/LinksNewsletter.vue';
import MentionsLanguage from './MentionsLanguage/MentionsLanguage.vue';
import PaymentSocials from './PaymentSocials/PaymentSocials.vue';
import Reinsurance from './Reinsurance/Reinsurance.vue';
import footerQuery from '~/graphql/footer.gql';
export default {
  name: 'TheFooter',
  components: {
    LinksNewsletter: LinksNewsletter,
    PaymentSocials: PaymentSocials,
    MentionsLanguage: MentionsLanguage,
    Reinsurance: Reinsurance
  },
  props: {
    locale: {
      type: Object,
      default: function _default() {
        return {
          market: '',
          language: ''
        };
      }
    }
  },
  data: function data() {
    return {
      routesOnNavModificationsExept: ['market-language']
    };
  },
  computed: {
    isCurrentRouteNeedsSEOOptimisation: function isCurrentRouteNeedsSEOOptimisation() {
      return !this.routesOnNavModificationsExept.includes(this.$route.name);
    }
  },
  apollo: {
    footer: {
      query: footerQuery,
      variables: function variables() {
        return {
          locale: this.locale.iso
        };
      }
    }
  }
};